export default class PerguntasList {
  static getList(){
    return [
      {
        'id': 1,
        'pergunta': 'Quais estabelecimentos e eventos devem oferecer o benefício?',
        'resposta': 'A meia entrada é direito de estudantes em todo território nacional, independente da existência de legislação local, em: </br>' +
        '<ul>' +
        '<li>Salas de cinema, cinseclubes, teatros, espetáculos musicais e circenses, museus e quaisquer equipamentos de natureza cultural;</li>' +
        '<li>Eventos educativos, esportivos, de lazer e de entretenimento promovidos por quaisquer entidades públicas ou privadas.</li>' +
        '</ul>'
      },
      {
        'id': 2,
        'pergunta': 'O que o estudante deve fazer para ter direito à meia-entrada?',
        'resposta': 'Portar e apresentar o Documento do Estudante dentro do prazo de validade (até 31 de março do ano seguinte à sua emissão), conforme modelo único nacionalmente padronizado pela <a href="https://www.une.org.br/">UNE</a>, <a href="https://ubes.org.br/2022/meia-entrada-2022/">UBES</a>, <a href="https://www.anpg.org.br/02/05/2022/meia-entrada-2022-quem-tem-direito/">ANPG</a> e pelo ITI no momento da aquisição do ingresso e na portaria do local do evento.'
      },
      {
        'id': 3,
        'pergunta': 'Quem pode emitir o Documento do Estudante?',
        'resposta': 'A carteira pode ser emitida pela Associação Nacional de Pós-Graduandos (ANPG), ' +
        'pela União Nacional dos Estudantes (UNE), pela União Brasileira dos Estudantes ' +
        'Secundaristas (UBES), pelas entidades estudantis em nível estadual e/ou municipal, ' +
        'pelos Diretórios Centrais dos Estudantes (DCEs) e Centros e Diretórios Acadêmicos, ' +
        'desde que seguida a padronização acima citada;'
      },
      {
        'id': 4,
        'pergunta': 'Posso utilizar outros documentos como comprovante da condição de estudante?',
        'resposta': 'Outros documentos, como comprovantes de matrícula e carteiras emitidas por escolas e universidades, não são válidos para comprovar a condição de estudante por não cumprirem com as determinações da lei da meia-entrada e não garantem a meia-entrada.'
      },
      {
        'id': 5,
        'pergunta': 'Como é possível verificar a autenticidade do Documento do Estudante?',
        'resposta': '<ul>' +
        '<li>O documento do estudante emitido de acordo com o padrão nacional poderá ser lido ' +
        'eletronicamente e o seu QR-Code (Quick Responsible Code ou Código de Resposta ' +
        'Rápida) que fornece o link para o certificado de atributo, que ao ser remetido ao validador da Meia Entrada possibilitará a consulta em tempo real da ' +
        'condição de estudante do portador;</li>' +
        '<li>E, por fim, os estabelecimentos, produtoras e promotoras de eventos podem integrar ' +
        'seus sistemas de vendas online diretamente ao validador do MeiaEntrada.org.br para consulta pública, ' +
        'por meio de API, site e aplicativo mobile, agilizando e automatizando o processo de vendas. Informações ' +
        'detalhadas, incluindo documentação da API, são encontradas no site ' +
        '<Link to="/validador/integre">http://www.meiaentrada.org.br/validador/integre</Link>.</li>' +
        '</ul>'
      },
      {
        'id': 6,
        'pergunta': 'Quais são as características do layout que diferenciam o Documento do Estudante?',
        'resposta': 'O layout e o posicionamento dos itens de segurança são alterados anualmente, mas o ' +
        'Documento do Estudante contém as seguintes características: ' +
        '<ul>' +
        '<li>Cartão do tipo PVC; </li>' +
        '<li>Fundo de tramas com efeito anti-scanner; </li>' +
        '<li>Impressões de textos em microletras; </li>' +
        '<li>Tinta sensível à luz ultravioleta e infravermelha (opcional). </li>' +
        '</ul>' +
        'Anualmente as entidades nacionais de representação ' +
        'estudantil publicam as características físicas e visuais do Padrão Nacional do Documento do ' +
        'Estudante, que devem ser seguidas por todas as entidades estudantis emissoras do Documento.'
      },
      {
        'id': 7,
        'pergunta': 'Existe uma reserva ou um limite para o número de ingressos que devem ser oferecidos aos estudantes?',
        'resposta': '<p>Os estabelecimentos devem reservar 40% dos ingressos para venda aos estudantes e outros ' +
        'beneficiários da meia-entrada (idosos, pessoas com deficiência e jovens de 15 a 29 anos ' +
        'comprovadamente carentes), até 48 horas antes do início do evento, em todos os pontos de ' +
        'venda de ingresso, físicos ou virtuais.</p>' +
        'No caso de eventos realizados em estabelecimentos com capacidade superior a 10 mil ' +
        'pessoas, o prazo para reserva é válido até 72 horas antes do evento.'
      },
      {
        'id': 8,
        'pergunta': 'Se a reserva de 40% esgotar, o estudante ainda pode comprar seu ingresso como meia-entrada?',
        'resposta': 'Mesmo que haja lugares disponíveis, quando o percentual destinado à meia-entrada se esgotar, o estudante não terá mais direito a pagar metade do valor do ingresso.'
      },
      {
        'id': 9,
        'pergunta': 'Posso acumular a meia-entrada com outros benefícios?',
        'resposta': 'O benefício não é cumulativo com outras promoções e convênio, nem tampouco com vantagens vinculadas à aquisição do ingresso por associado de entidade esportiva, como sócio-torcedor, descontos promocionais e similares. Esses ingressos não serão considerados no cálculo do percentual de 40%.'
      },
      {
        'id': 10,
        'pergunta': 'A cota de 40% pode ser limitada a apenas uma categoria de ingressos?',
        'resposta': 'Não, a cota aplica-se a todas as categorias de ingressos disponíveis para venda ao público, camarotes, área e cadeiras especiais, se vendidos de forma individual e pessoal, mas não é válido para o valor dos serviços eventualmente oferecidos nessas categorias. O desconto de 50% não será cumulativo com outros oferecidos por leis estaduais ou municipais.'
      },
      {
        'id': 11,
        'pergunta': 'Os estabelecimentos precisam disponibilizar informações sobre o benefício da meia-entrada?',
        'resposta': 'Sim. Os estabelecimentos, as produtoras e as promotoras de eventos devem disponibilizar, de forma clara e ostensiva, as informações: ' +
        '<ul>' +
        '<li>A transcrição do artigo 1º, da Lei nº12.933 de 2013, sobre as condições estabelecidas para a meia-entrada;</li>' +
        '<li>Os elementos ou foto do Documento do Estudante;</li>' +
        '<li>Os telefones do Procon e Ministério Público que são os órgãos de fiscalização.</li>' +
        '</ul>'
      },
      {
        'id': 12,
        'pergunta': 'Em que locais estas informações devem estar disponíveis?',
        'resposta': '<p>Estas informações deverão ser prestadas, antes de a venda ser finalizada, em todos os pontos de comercialização de ingressos, físicos ou virtuais, assim como na portaria ou na entrada do local de realização do evento.</p>' +
        'As informações não poderão estar apenas em áreas do site não relacionadas à venda dos ingressos, como “Termo de Uso”; precisam estar apresentadas de forma clara para acesso antes da realização da compra.'
      },
      {
        'id': 13,
        'pergunta': 'O que diz o artigo que precisa ser transcrito e comunicado pelos estabelecimentos?',
        'resposta': '<p>“Art. 1º da Lei nº 12.933 - É assegurado aos estudantes o acesso a salas de cinema, cineclubes, teatros, espetáculos musicais e circenses e eventos educativos, esportivos, de lazer e de entretenimento, em todo o território nacional, promovidos por quaisquer entidades e realizados em estabelecimentos públicos ou particulares, mediante pagamento da metade do preço do ingresso efetivamente cobrado do público em geral.</p>' +
        '<p>§1º O benefício previsto no caput não será cumulativo com quaisquer outras promoções e convênios e, também, não se aplica ao valor dos serviços adicionais eventualmente oferecidos em camarotes, áreas e cadeiras especiais.</p>' +
        '§2º terão direito ao benefício os estudantes regularmente matriculados nos níveis e modalidades de educação e ensino previstos no Título V da Lei nº 9.394, de 20 de dezembro de 1996, que comprovem sua condição de discente, mediante a apresentação, no momento da aquisição do ingresso e na portaria do local de realização do evento, da Carteira de Identificação Estudantil (CIE), emitida pela Associação Nacional de Pós-Graduandos (ANPG), pela União Nacional dos Estudantes (UNE), pela União Brasileira dos Estudantes Secundaristas (Ubes), pelas entidades estaduais e municipais, pelos Diretórios Centrais dos Estudantes (DCEs) e pelos Centros e Diretórios Acadêmicos, com prazo de validade renovável a cada ano, conforme modelo único nacionalmente padronizado e publicamente disponibilizado pelas entidades nacionais antes referidas e pelo Instituto Nacional de Tecnologia da Informação (ITI), com certificação digital deste, podendo a carteira de identificação estudantil ter 50% (cinquenta por cento) de características locais.”'
      },
      {
        'id': 14,
        'pergunta': 'Os estabelecimentos precisam disponibilizar relatórios de venda de ingressos?',
        'resposta': '<p>Sim, é necessário elaborar um relatório da venda de ingressos após o encerramento das vendas, como indicação dos totais comercializados e aqueles vendidos como meia-entrada. Deverá ser mantido por 30 dias a partir da data da realização de cada evento, em meio eletrônico ou físico;</p>' +
        'Os relatórios devem ser disponibilizados sempre que solicitados aos órgãos de fiscalização e entidades nacionais de representação estudantil, detalhados e mediante comprovação da venda da meia-entrada por meio da apresentação do Documento do Estudante com indicação do número de registro.'
      },
      {
        'id': 15,
        'pergunta': 'É possível oferecer o benefício da meia-entrada estudantil a todo o público?',
        'resposta': 'Há disposições legais que garantem meia-entrada a outros cidadãos. Contudo, se o estabelecimento oferecer um desconto de 50% ao público, o estudante terá direito ao pagamento da metade do valor.'
      },
      {
        'id': 16,
        'pergunta': 'Quem é responsável pela fiscalização da concessão da meia-entrada?',
        'resposta': 'Os órgãos de defesa do consumidor, como Procons estaduais e municipais, Secretaria Nacional de Defesa do Consumidor do Ministério da Justiça, Ministério Público e entidades nacionais de representação estudantil (UNE, UBES e ANPG).'
      },
      {
        'id': 17,
        'pergunta': 'Qual a punição prevista para estabelecimentos que descumprirem a lei da meia-entrada?',
        'resposta': 'O descumprimento da lei sujeita os estabelecimentos, produtoras e promotoras responsáveis pelos eventos culturais e esportivos a sanções administrativas previstas no Código de Defesa do Consumidor, que incluem:' +
        '<ul>' +
        '<li>Multa;</li>' +
        '<li>Suspensão temporária de atividade;</li>' +
        '<li>Revogação de concessão ou permissão de uso;</li>' +
        '<li>Cassação de licença do estabelecimento ou de atividade;</li>' +
        '<li>Interdição, total ou parcial, de estabelecimento, de obra ou de atividade;</li>' +
        '<li>Intervenção administrativa;</li>' +
        '<li>Imposição de contrapropaganda.</li>' +
        '</ul>'
      }
    ];
  }
}


// WEBPACK FOOTER //
// ./src/components/views/PerguntasRespostas/PerguntasList.js